import React from 'react';

const STATUS_STYLES = {
  PENDING: 'bg-amber-100 text-amber-800',
  APPROVED: 'bg-emerald-100 text-emerald-800',
  DENIED: 'bg-red-100 text-red-800',
};

const STATUS_LABELS = {
  PENDING: 'Pending Approval',
  APPROVED: 'Approved',
  DENIED: 'Denied',
};

function VacationApprovalBadge({ status }) {
  const normalizedStatus = status || 'PENDING';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[normalizedStatus] || STATUS_STYLES.PENDING}`}>
      {STATUS_LABELS[normalizedStatus] || normalizedStatus}
    </span>
  );
}

export default VacationApprovalBadge;
